import React, { useState } from "react";

const fallbackImage = "/img/user.png"; // Adjust the path to your actual fallback image

const UserAvatar = ({ src, alt = "User", size = 45, className = "" }) => {
  const [imgSrc, setImgSrc] = useState(src || fallbackImage);

  const handleImgError = () => {
    setImgSrc(fallbackImage);
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      onError={handleImgError}
      className={`rounded-circle bg-secondary object-fit-cover ${className}`}
      style={{
        width: size,
        height: size,
        objectFit: "cover",
      }}
    />
  );
};

export default UserAvatar;
